<template>
  <Dropdown
    :style="{width: '100%', position: 'relative'}"
    :visible="visible"
    class="customDrop"
    ref="dropRef"
    trigger="custom"
  >
    <Input
      :icon="visible?'ios-arrow-up':'ios-arrow-down'"
      @on-clear="clear"
      @on-click="handleOpen"
      @on-focus="handleOpen"
      autocomplete="off"
      placeholder="请选择区域"
      readonly
      v-model="areaNameStr"
    ></Input>
    <DropdownMenu slot="list">
      <div class="treePanel">
        <div class="treeContainer">
          <Tree
            :check-strictly="true"
            :data="data"
            :load-data="loadData"
            :multiple="true"
            :render="renderContent"
            @on-select-change="changeSelectNode"
            class="areaTree"
          ></Tree>
        </div>
      </div>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
export default {
  name: 'knowledgeArea',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    value: {
      handler (val) {
        this.chkAreaList = val
        const al = []
        for (const v in val) {
          this.areaCodes.push(val[v].fullCode)
          this.areaNames.push(val[v].name)
          al.push(val[v].name)
        }
        this.$emit('change', this.areaCodes)
        this.areaNameStr = al.join('，')
        this.dealTreeData()
      },
      immediate: true
    }
  },
  data () {
    return {
      visible: false,
      current: null,
      data: [],
      areaCodes: [],
      areaNames: [],
      chkAreaList: [],
      areaNameStr: '',
    }
  },
  methods: {
    changeSelectNode: function (checked, current) {
      this.current = current
      if (current.selected) {
        this.areaCodes.push(current.fullCode)
        this.areaNames.push(current.name)
      } else {
        this.areaCodes = this.areaCodes.filter(item => item !== current.fullCode)
        this.areaNames = this.areaNames.filter(item => item !== current.name)
      }
      this.$emit('change', this.areaCodes)
      this.areaNameStr = this.areaNames.join('，')
      this.$emit('changeSelectNode', { checked: checked.length > 0, node: current })
    },
    close: function () {
      this.visible = false
    },
    handleOpen: function () {
      this.visible = !this.visible
    },
    clear: function () {
      this.close()
    },
    outClick (e) {
      let dropRef = this.$refs.dropRef.$el
      if (!dropRef.contains(e.target) && this.visible) {
        this.visible = false
      }
    },
    traverseTree: function (nodes, chkNames) {
      if (nodes === null || nodes === undefined || nodes.length === 0) return
      for (let i = 0; i < nodes.length; i++) {
        if (this.areaCodes.includes(nodes[i].fullCode)) {
          this.$set(nodes[i], 'selected', true)
          chkNames.push(nodes[i].name)
        }
        this.traverseTree(nodes[i].children, chkNames)
      }
    },
    dealTreeData: function () {
      let nameArr = []
      if (this.areaCodes.length > 0) {
        this.traverseTree(this.data, nameArr)
      }
      // this.areaNameStr = nameArr.join('，')
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, [
        h('span', {
          style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }, [
          h('span', data.name)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '1.2rem'
          }
        }, [
        ])
      ])
    },
    search: function (fullCode, callback) {
      let that = this
      this.$Spin.show()
      let params = new this.$URLSearchParams()
      if (fullCode) params.append("fullCode", fullCode)
      this.$axios.get(that.$apis.dictionaryManager.region.subTreeByFullCode + "?fullCode=" + fullCode).then(res => {
        if (res.success) {
          if (callback) {
            callback(res.result || [])
            that.dealTreeData()
          } else {
            that.data = [{
              name: '中国',
              expand: true,
              type: 'country',
              fullCode: '000000000000',
              loading: false,
              children: res.result || []
            }]
            that.dealTreeData()
          }

        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('区域树获取失败！')
      }).then(val => {
        that.$Spin.hide()
      })
    },
    loadData: function (item, callback) {
      this.search(item.fullCode, callback)
    }
  },
  beforeMount () {
    this.close()
    document.getElementById("app").addEventListener('click', this.outClick)
    this.search("000000000000")
  },
  beforeDestroy () {
    this.close()
    document.getElementById("app").removeEventListener('click', this.outClick)
  }
}
</script>

<style scoped>
.treePanel {
  padding: 0 1rem;
  max-width: 600px;
}
</style>